import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import InfiniteScroll from 'react-infinite-scroller';
import { withRouter } from 'react-router-dom';
import querystring from 'qs';
import parseLinkHeader from 'parse-link-header';

import Container from '../components/Container';
import SceneList from './SceneList';
import ContentRows from '../components/ContentRows';
import { FONT_SIZE_BIG, ITEM_TYPES } from '../constants';
import { crossScreenFontSize, crossScreenPaddingTop, toVw, toVwMobile, toVwTablet } from '../utils/styles';
import mq from '@/utils/media-queries';
import Indent from '../components/Indent';
import api from '../utils/api';
import AnimationOnPageLoadItem from '../components/AnimationOnPageLoadItem';

const PREFACE_MARGIN_BOTTOM = 144;

const Preface = styled.div`
  ${crossScreenPaddingTop(146)};
  ${crossScreenFontSize(FONT_SIZE_BIG)};
  margin-bottom: ${toVw(PREFACE_MARGIN_BOTTOM)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(PREFACE_MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(PREFACE_MARGIN_BOTTOM)};
  `)};
`;

class InfiniteScrollScene extends React.Component {
  static propTypes = {
    page: PropTypes.oneOf([ITEM_TYPES.case, ITEM_TYPES.news]),
    location: PropTypes.object.isRequired,
    prefaceText: PropTypes.string,
    progressStore: PropTypes.object.isRequired,
    loadMoreFunc: PropTypes.func.isRequired,
  };

  state = {
    rows: [],
    hasMore: true,
  };

  componentDidMount() {
    this.load();
  }

  getCategory() {
    return querystring.parse(this.props.location.search.slice(1)).category;
  }

  load = async () => {
    if (!this.state.hasMore) {
      return;
    }

    const category = this.getCategory();

    const response = this.next ? await api.fetch(this.next.url) : await this.props.loadMoreFunc(category);
    const linkHeader = response.headers.get('Link');
    const parsed = linkHeader ? parseLinkHeader(linkHeader) : {};

    if (!parsed.next || !parsed.next.url) {
      this.setState({ hasMore: false });
    } else {
      this.next = { ...parsed.next };
    }

    const { rows } = await response.json();

    rows &&
      this.setState(prevState => ({
        rows: [...prevState.rows, ...rows],
      }));
  };

  handleScrollLoadMore = () => {
    this.load();
  };

  render() {
    const { prefaceText, ...rest } = this.props;

    return (
      <SceneList {...rest}>
        <Container>
          {prefaceText && (
            <Indent>
              <AnimationOnPageLoadItem>
                <Preface dangerouslySetInnerHTML={{ __html: prefaceText }} data-hide-on-animation />
              </AnimationOnPageLoadItem>
            </Indent>
          )}
          <AnimationOnPageLoadItem>
            <InfiniteScroll
              initialLoad={false}
              loadMore={this.handleScrollLoadMore}
              hasMore={this.state.hasMore}
              useWindow={true}
              threshold={1000}
            >
              <ContentRows items={this.state.rows} page={this.props.page} />
            </InfiniteScroll>
          </AnimationOnPageLoadItem>
        </Container>
      </SceneList>
    );
  }
}

export default withRouter(
  inject(stores => ({
    progressStore: stores.store.progress,
  }))(observer(InfiniteScrollScene))
);



// WEBPACK FOOTER //
// ./src/scenes/InfiniteRowsScene.js